module.exports = __webpack_public_path__ + "static/011-slideshow-ce6572e5def7d217d051af058572f5a4.jpg";